import api from './api';

export interface PortalNotification {
  id: number;
  kind: string;
  title: string;
  body: string | null;
  link: string | null;
  createdAt: string;
  readAt: string | null;
}

export interface NotificationFeed {
  items: PortalNotification[];
  unread: number;
}

/** The signed-in reader's notifications, in the language they are browsing in. */
export async function fetchNotifications(lang: string): Promise<NotificationFeed> {
  const { data } = await api.get<NotificationFeed>('/notifications', {
    params: { lang: lang?.startsWith('fr') ? 'fr' : 'en', limit: 20 },
  });
  return data;
}

export async function markNotificationRead(id: number): Promise<void> {
  await api.post(`/notifications/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<void> {
  await api.post('/notifications/read-all');
}

export async function fetchReportEmailPreference(): Promise<boolean> {
  const { data } = await api.get<{ reportEmails: boolean }>('/notifications/preferences');
  return !!data.reportEmails;
}

export async function saveReportEmailPreference(reportEmails: boolean): Promise<boolean> {
  const { data } = await api.put<{ reportEmails: boolean }>('/notifications/preferences', { reportEmails });
  return !!data.reportEmails;
}
